export default __webpack_public_path__ + "fonts/5a87f7c487cd10f7fccce062881c2283.woff";